<template>
  <div class="event-banner">
    <div
      v-for="event in eventBannerList"
      :key="event.eventid"
      class="event"
    >
      <a
        href="javascript:void(0)"
        @click.prevent="goToEventDetailPage(event)"
        :style="`background-color: ${event.bgcolor}`"
      >
        <img :src="getImage(event.bannerimage)" :alt="event.title">
      </a>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
import { resizeThumbnail } from '@/common/image.filter'

export default {
  name: 'EventBannerList',
  props: {
    eventBannerList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    getImage (img) {
      return resizeThumbnail(img, { width: 0, height: 0, option: '20', quality: 80 })
    },
    goToEventDetailPage (event = {}) {
      const eventId = _.get(event, 'eventid', '')

      this.$router.push({
        path: `/event/detail/${eventId}`
      })
    }
  }
}
</script>
